import { Modal } from "@mui/material";
import React from "react";
import Styles from "./Popup.module.css";
import { ReactComponent as Tick } from "../../assets/images/Tick.svg";
import { useNavigate } from "react-router-dom";
const Popup = ({
  open,
  handleClose,
  onClick,
  isInForgot = false,
  heading,
  content,
  onClose,
  onConfirm,
}) => {
  const navigate = useNavigate();

  // Determine the props to use based on the pattern
  const isOpen = typeof open === "function" ? false : open;
  const handleCloseAction = handleClose || onClose;
  const handleConfirmAction = onClick || onConfirm;

  // Default content based on context
  const popupHeading =
    heading ||
    (isInForgot ? "Password Reset Successful" : "Registration Completed");
  const popupContent =
    content ||
    (isInForgot
      ? "Your password has been successfully reset. You can now login with your new password."
      : "Thank you for registering on the GNA OTC Platform. Your account is under verification, and access is temporarily restricted. Check status in 24-48 hours or contact admin@gna.energy for urgent requests.");

  const handleOkClick = () => {
    if (isInForgot) {
      // navigate("/login");
      window.location.reload();
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleCloseAction}
        aria-labelledby="success-popup"
      >
        <div className={Styles.popupModelContainerReg}>
          <div className={Styles.popModelSubContainer}>
            <div className={Styles.popHeadingReg}>{popupHeading}</div>
          </div>
          <div className={Styles.popUpContentReg}>
            <div className={Styles.tick}>
              <Tick />
            </div>
            <div className={Styles.popUpContentTextReg}>{popupContent}</div>
          </div>
          <div className={Styles.popUpConfirmationReg}>
            <div className={Styles.okConfirmation} onClick={handleOkClick}>
              OK
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Popup;
